<template>
    <ErrorPage
            :title="$t('errors.disabled.title')"
            :description="$t('errors.disabled.description')"
            @back="back"
    />
</template>

<script>
    import { ErrorPage } from "@tech_hexeko/design-system"

    export default {
        components: {
            ErrorPage
        },
        methods: {
            back() {
                this.$router.push({
                    path: '/logout',
                    root: true
                })
            },
            checkUserIsNotAlreadyEnabled() {
                if(this.$store.getters['auth/passUserEnabled']) {
                    this.next()
                }
            },
            next() {
                let redirect = this.$route.query.redirect
                this.$router.push(redirect ? redirect : '/')
            }
        },
        computed: {
            user: function() {
                return this.$store.state.auth.user
            }
        },
        watch: {
            user: {
                handler: function () {
                    this.checkUserIsNotAlreadyEnabled()
                },
                deep: true,
                immediate: true
            }
        }
    }
</script>